<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import TruckWeightCapacityPageTable from './TruckWeightCapacityPageTable'
const { CrudLayoutSearch } = JtCrud

@Component({
  name: 'TruckWeightCapacity',
  mixins: [CrudLayoutSearch],
  components: {
    TruckWeightCapacityPageTable
  }
})
class TruckWeightCapacity extends Vue {
  get _pageTable () {
    return TruckWeightCapacityPageTable
  }

  async actionButton (button, params, page) {
    const paramsTemp = { ...params }
    delete paramsTemp.imageGrid
    if (this.buttonExtra[button.name]) {
      this.buttonExtra[button.name].action({
        button: button,
        params: { ...this.params, ...paramsTemp },
        page: page
      })
    } else {
      await this.actionButtonDefault(
        button,
        { ...this.params, ...paramsTemp },
        page
      )
    }
  }
}
export default TruckWeightCapacity
</script>
<style lang="stylus" scoped></style>
